import { config } from '../config/config';
import consentTypes from './consentTypes';

export default (cookieName, cookieType) => {
    // eslint-disable-next-line no-unused-vars
    const additionalFilter = (cookieTypeToFilter, cookieNameToFilter) => {
        if (cookieTypeToFilter === consentTypes.CONSENT_TYPE_STATISTICS) {
            // return new RegExp('your_additional_statistic_filter').test(cookieNameToFilter);
        }
        if (cookieTypeToFilter === consentTypes.CONSENT_TYPE_MARKETING) {
            // return new RegExp('your_additional_marketing_filter').test(cookieNameToFilter);
        }
        return false;
    };

    const result = config.externalCookieNames[cookieType].filter((externalCookieName) => {
        return new RegExp(`^${externalCookieName}`).test(cookieName) || additionalFilter(cookieType, cookieName);
    });

    return result.length > 0;
};
